<template>

    <transition name="fade-slide">
        <div class="brt-guide-drawer" v-if="visible"  @click.self="close">
            <div class="brt-guide fade-slide-right">
                <div class="brt-guide-head" @click="$mapStore.plugInfo.phone ? '': showLogin()">

                    <div class="headpic">

                        <img src="../../../public/images/login.png" alt="">

                    </div>

                    <div class="phone">
                        {{$mapStore.plugInfo.phone ? $mapStore.plugInfo.phone:'登录云同步'}}
                    </div>

                    <div class="btn" @click="$mapStore.plugInfo.phone ? selectWayDialog = true : ''">
                        <i class="iconfont icon-change"></i>
                    </div>

                </div>

                <div class="brt-guide-body">
                    <div class="brt-guide-toggle">
                        <div class="tog" :class="{active: !use3D}" @click="changeUse3D(false)">
                            <img src="../../../public/images/2D.png" alt="">
                            <span>2D平面图</span>
                        </div>
                        <div class="tog" :class="{active: use3D}" @click="changeUse3D(true)">
                            <img src="../../../public/images/3D.png" alt="">
                            <span>3D立体图</span>
                        </div>
                    </div>

                    <ul class="brt-guide-switch">
                        <li v-for="(item, index) in switchArray" v-if="item.show">
                            <div class="l">
                                <img :src="item.icon" alt="">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="r">
                                <i class="iconfont" :class="'icon-switch-' + (item.checked ? 'on' : 'off')" @click="switchClick(item)"></i>
                            </div>
                        </li>
                    </ul>

                    <ul class="brt-guide-button">

                        <li @click="footTable(1)">
                            <div class="l">
                                <img src="../../../public/images/collected.png" alt="">
                                <span>收藏夹</span>
                            </div>
                            <div class="r">
                                <i class="iconfont icon-right-01"></i>
                            </div>
                        </li>

                        <li @click="footTable(2)">
                            <div class="l">
                                <img src="../../../public/images/foot.png" alt="">
                                <span>历史足迹</span>
                            </div>
                            <div class="r">
                                <i class="iconfont icon-right-01"></i>
                            </div>
                        </li>

                    </ul>

                </div>
            </div>

            <!--选择操作方式-->
            <Dialog v-model="selectWayDialog" title="选择操作方式" title-background>
                <div class="select-handle-way">
                    <div class="title">账户尊享数据永久云同步！</div>
                    <div class="buttons">
                        <span @click="loginOut">退出登录</span>
                        <span @click="showLogin">切换账号</span>
                    </div>
                </div>
            </Dialog>

            <!--登录模块-->
            <Login v-model="loginVisible"></Login>
        </div>
    </transition>
</template>

<script>

    import { Dialog } from '@/components/dialog'
    import { Login } from '@/modules/login'

    export default {
        name: "GuideDrawer",
        components: {
            Dialog,
            Login
        },

        data() {
            return {
                visible: this.value,
                //选择方式
                selectWayDialog: false,
                //登录
                loginVisible: false,

                use3D: this.$mapStore.plugInfo.plugInfo.plugInSettings && JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.map).inclineAngle >= 30 ? true : false ,

                switchArray: [
                    {
                        name: '热力图',
                        key: 'heatmap',
                        icon: './images/guide.png',
                        checked: false,
                        show:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).hotMap == 'close' ? false : true
                    },
                    {
                        name: '导航语音',
                        key: 'voice',
                        icon: './images/video.png',
                        checked: true,
                        show:true,
                    }
                ]
            }
        },
        props: {
            value: {
                default: false
            }
        },
        watch: {
            value(boolean) {
                this.visible = boolean;
            },

            $use3D(v1,v2){
                this.use3D = v1
            }
        },

        computed:{
            $use3D(){return this.$BRT.$options.use3D;}
        },
        methods: {
            close() {
                // this.reset();
                this.$emit('input', this.visible = false);
                this.$emit('on-close', this.visible);
            },

            changeUse3D (boolean) {
                this.use3D = boolean;

                if(this.use3D){

                    $VAR.map.easeTo({pitch: 30})

                }else{

                    $VAR.map.easeTo({pitch:0})

                }

            },

            switchClick (item) {

                item.checked = !item.checked;

                //语音开关
                if(item.key == 'voice'){
                    item.checked ? this.$message.info('已开启导航语音') : this.$message.info('已关闭导航语音');
                    this.$BRT.$options.voice =  item.checked
                }

                if(item.key == 'heatmap'){
                    item.checked ? this.$message.info('已开启实时客流热力图') : this.$message.info('已关闭实时客流热力图');
                }

            },

            footTable(index){

                if(!this.$mapStore.plugInfo.phone){
                    this.$message.info('请先登录');
                    this.bus.$emit('LoginCallback',{status:1});
                    return;
                }

                this.$BRT.$options.Footprint = true,this.$BRT.$options.FootprintTabIndex = index;
            },

            showLogin () {
                this.selectWayDialog = false;
                this.loginVisible = true;
            },

            //退出登录
            loginOut(){

                this.selectWayDialog=false;
                this.loginVisible = false;

                if(this.$mapStore.plugInfo.phone){
                    this.$message.info('已退出登录');
                }else{
                    this.$message.info('未登录')
                }

                this.$store.state.CollectData = [];
                this.$store.state.HistoryData = [];

                this.$mapStore.plugInfo.phone = '';

                window.localStorage.setItem('phone','');

                window.sessionStorage.setItem('pluginInfo',JSON.stringify(this.$mapStore.plugInfo))
            }

        },
    }
</script>

<style lang="less">
    @import "../../styles/cssBlock.less";

    .brt-guide-drawer {
        .fixedByCover();
        pointer-events: auto;
        background-color: @maskBgColor;
        z-index: 9000;

        > .brt-guide {
            display: flex;
            flex-direction: column;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 58%;
            max-width: @450px;
            background-color: #FFFFFF;
            box-shadow: 0 0 @shadowSize @shadowColor;

            > .brt-guide-head {
                display: flex;
                padding: @spacingNumber;
                align-items: center;
                border-bottom: 1px solid @borderColorA2;

                > .headpic {
                    width: @75px;
                    height: @75px;
                    border-radius: 50%;
                    background-color: @fontColorA4;
                    font-size: 0;

                    > img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                > .phone {
                    flex: 1;
                    padding: 0 @20px;
                    color: @fontColorA1;
                }

                > .btn {
                    > .iconfont {
                        font-size: @30px;
                        color: @fontColorA2;
                    }
                }
            }

            > .brt-guide-body {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                min-height: 1px;
            }

            .brt-guide-toggle {
                display: flex;
                padding: @spacingNumber @spacingNumber - @10px;
                padding-top: @spacingNumber * 2;

                > .tog {
                    flex: 1;
                    padding: @10px;
                    text-align: center;

                    &.active {
                        > img {
                            box-shadow: 0 0 0 @4px var(--themColor);
                        }
                    }

                    > img {
                        width: 100%;
                    }

                    > span {
                        font-size: @normalFontSize - @2px;
                        color: @fontColorA1;
                    }
                }
            }

            .brt-guide-switch,
            .brt-guide-button {

                > li {
                    display: flex;
                    align-items: center;
                    padding: 0 @spacingNumber;

                    > .l {
                        flex: 1;
                        padding: @spacingNumber - @5px 0;

                        > img {
                            width: @60px;
                            height: @60px;
                            vertical-align: middle;
                        }

                        > span {
                            display: inline-block;
                            font-size: @28px;
                            color: @fontColorA1;
                            padding: 0 @20px;
                            position: relative;
                            top: 1px;
                        }
                    }

                    > .r {
                        > .iconfont {
                            font-size: @42px;
                            color: @fontColorA3;
                        }

                        > .icon-switch-on {
                            color: var(--themColor);
                        }
                    }
                }
            }

            .brt-guide-button {
                > li {
                    &:active {
                        background-color: @activeBgColorA1;
                    }

                    > .r {
                        > .iconfont {
                            font-size: @24px;
                        }
                    }
                }
            }
        }

        .select-handle-way {
            text-align: center;
            padding-bottom: @spacingNumber * 1.5;

            > .title {
                padding: @spacingNumber * 2 0;
                color: @fontColorA2;
            }

            > .buttons {
                @height     : @80px;
                > span {
                    display: inline-block;
                    width: @210px;
                    height: @height;
                    line-height: @height;
                    border: 1px solid @fontColorA3;
                    border-radius: @height - @10px;
                    font-size: @normalFontSize - @2px;
                    color: @fontColorA3;
                    margin: 0 @15px;
                    vertical-align: top;

                    &:active {
                        border-color: @fontColorA2;
                        color: @fontColorA2;
                    }

                    &:last-child {
                        background-color: @fontColorA3;
                        color: #FFFFFF;

                        &:active {
                            background-color: @fontColorA2;
                        }
                    }
                }
            }
        }
    }
</style>
